import { useMediaQuery } from './useMediaQuery'

/**
 * Custom hook for device type detection
 *
 * USE CASES:
 * - Layout decisions (navigation, player panels)
 * - Component rendering logic
 * - Responsive behavior patterns
 *
 * @returns {Object} Device type flags
 * @example
 * // ✅ Primary use case
 * const { isMobile, isTabletVertical } = useDeviceType()
 *
 * @see useMediaQuery For specific media queries (prefers-reduced-motion, etc.)
 */
export function useDeviceType () {
  // Mobile: < 600px
  const isMobile = useMediaQuery('(max-width: 599px)')

  // Tablet Vertical: 600px-899px + portrait orientation
  const isTabletVertical = useMediaQuery('(min-width: 600px) and (max-width: 899px) and (orientation: portrait)')

  // Tablet Horizontal OR Desktop: ≥600px + landscape OR ≥900px (any orientation)
  const isTabletHorizontalOrDesktop = useMediaQuery('(min-width: 600px) and ((orientation: landscape) or (min-width: 900px))')

  // Desktop breakpoints for fine-grained control
  const isDesktop = useMediaQuery('(min-width: 768px)')
  const isLargeDesktop = useMediaQuery('(min-width: 1200px)')

  return {
    // Primary breakpoints
    isMobile,
    isTabletVertical,
    isTabletHorizontalOrDesktop,

    // Desktop specific
    isDesktop,
    isLargeDesktop
  }
}
